import { toastr } from 'react-redux-toastr';
import {
    pendingTask,
    begin,
    end,
} from 'react-redux-spinner';
import { LOADING_START, LOADING_END } from '../../../store/loading';
import { UPDATE_EMPLOYEE_GLOBAL_SETUP } from './globalSetup.actions';
import {
    getEmployeeGlobalSetup,
} from '../../services/api-endpoints';

/** @type { () => (dispatch: import('redux').Dispatch) => void} */
export const fetchEmployeeGlobalSetup = () => async (dispatch) => {
    dispatch({ type: LOADING_START, [pendingTask]: begin });

    try {
        const { data: employeeGlobalResponse } = await getEmployeeGlobalSetup();

        dispatch({
            type: UPDATE_EMPLOYEE_GLOBAL_SETUP,
            payload: {
                ...employeeGlobalResponse,
                isGlobalSetupDataLoaded: true,
                reset: employeeGlobalResponse,
            },
        });
    } catch (error) {
        // @ts-ignore
        toastr.error('Loading app data', error.response?.data?.Message || 'Failed to load global setup');
    } finally {
        dispatch({ type: LOADING_END, [pendingTask]: end });
    }
};
